export default "__VITE_ASSET__Cyp_7hUm__"